/* eslint-disable  @typescript-eslint/no-explicit-any */

import { Component, OnInit } from '@angular/core';
import { EvidenceBrokerService } from '../_service/evidence-broker.service'
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { QUERY_BY_PROCEDURE_AND_JURISDICTION, EB_COUNTRIES, EB_PROCEDURE_IDS, QUERY_BY_REQUIREMENTS_AND_JURISDICTION } from './constants';
import { DEFAULT_LANGUAGE } from '../contants';
import { Select2Data, Select2UpdateEvent, Select2UpdateValue } from 'ng-select2-component';

@Component({
  selector: 'app-evidence-broker',
  templateUrl: './evidence-broker.component.html'
})
export class EvidenceBrokerComponent implements OnInit {

  public request: any;
  public response: any;
  public requirementIds: Select2Data;
  ebForm: FormGroup;
  formBuilder: FormBuilder;
  queryIdList = [QUERY_BY_PROCEDURE_AND_JURISDICTION];
  countryList = EB_COUNTRIES;
  procedureIdList = EB_PROCEDURE_IDS;

  notSelectedValue = { value: 0, label: "Not selected" };

  countries: Select2Data = EB_COUNTRIES.map(country => ({
    value: country.code,
    label: country.name,
    data: {
      image: "assets/country-flags/" + country.code.toLocaleLowerCase() + ".webp"
    }
  }));

  selectedCountry: Select2UpdateValue;

  constructor(private ebService: EvidenceBrokerService) { }

  ngOnInit(): void {
    this.ebForm = new FormGroup({
      queryId: new FormControl(QUERY_BY_PROCEDURE_AND_JURISDICTION, Validators.required),
      countryCode: new FormControl(),
      procedureId: new FormControl(),
      requirementId: new FormControl()
    });

    this.countries.unshift(this.notSelectedValue);
    this.selectedCountry = 0;
    this.fetchEvidenceCountries();

    const queryParams = { "queryId": QUERY_BY_PROCEDURE_AND_JURISDICTION };
    this.doSearch(queryParams);
  }

  onRequirementChange(event: Select2UpdateEvent<Select2UpdateValue>) {
    this.ebForm.get("requirementId")?.setValue(event.value);
    if (this.ebForm.valid) {
      this.doSearch(this.ebForm.value);
    }
  }

  onCountryChange(event: Select2UpdateEvent<Select2UpdateValue>) {
    this.requirementIds = [];
    this.ebForm.get("requirementId")?.setValue(null);
    this.ebForm.get("countryCode")?.setValue(event.value);
    if (this.ebForm.valid) {
      this.doSearch(this.ebForm.value);
    }
  }

  fetchEvidenceCountries() {
    this.ebService.getEvidenceCountries(DEFAULT_LANGUAGE).subscribe(
      {
        next: result => {
          this.countryList = result?.evidenceCountries;
        },
        error: (e) => console.error(e),
        complete: () => console.log('complete')
      });
  }

  doSearch(queryParams: any): void {

    let isEvidenceTypeQuery = false;

    if(queryParams.requirementId != null && queryParams.requirementId != undefined) {
      queryParams.queryId = QUERY_BY_REQUIREMENTS_AND_JURISDICTION;
      isEvidenceTypeQuery = true;
    }
    this.ebService.search(queryParams).subscribe(
      {
        next: result => {
          this.response = result;
          if(!isEvidenceTypeQuery && result) this.requirementIds = result.requirementTypes.map((req: { identifier: any; name: any; }) => ({
            value: req.identifier,
            label: req.name
          }));
        },
        error: (e) => {
          this.response = e;
          console.error(e.error.message)
        },
        complete: () => console.log('complete')
      });
  }

  

  listRequirementIds(procedureId: string): void {
    this.ebService.listRequirementIds(procedureId, DEFAULT_LANGUAGE).subscribe(
      {
        next: result => {
          this.requirementIds = result.requirementTypes;
          console.info(result);
        },
        error: (e) => console.error(e.error.message),
        complete: () => console.log('complete')
      });
  }
}

